import type { Synop as ServiceSynop } from './api/Synop'
import DateService from '@services/DateService'

export class Synop {
  id: any
  heightSensorMarinePlatform: any
  yearSynop: any
  monthSynop: any
  daySynop: any
  hourSynop: any
  minuteSynop: any
  pressureReducedToMeanSeaLevel: any
  twentyfourHourPressureChange: any
  pressure: any
  airTemperature: any
  dewpointTemperature: any
  relativeHumidity: any
  horizontalVisibility: any
  totalPrecipitation24Hours: any
  cloudCoverTotal: any
  heightOfBaseOfCloud: any
  totalSnowDepth: any
  precipitationType: any
  totalSunshine: any
  totalPrecipitationOrTotalWaterEquivalent: any
  maximumTemperatureAtHeightAndOverPeriodSpecified: any
  minimumTemperatureAtHeightAndOverPeriodSpecified: any
  windDirection: any
  windSpeed: any
  maximumWindGustDirection: any
  maximumWindGustSpeed: any
  netWaveRadiationIntegratedOverPeriodSpecified: any
  diffuseSolarRadiationIntegratedOverPeriodSpecified: any
  directSolarRadiationIntegratedOverPeriodSpecified: any

  constructor(serviceSynop: ServiceSynop) {
    this.id = serviceSynop.ID_SYNOP
    this.heightSensorMarinePlatform = serviceSynop.HEIGHT_SENSOR_MARINE_PLATFORM
    this.yearSynop = serviceSynop.YEAR_SYNOP
    this.monthSynop = serviceSynop.MONTH_SYNOP
    this.daySynop = serviceSynop.DAY_SYNOP
    this.hourSynop = serviceSynop.HOUR_SYNOP
    this.minuteSynop = serviceSynop.MINUTE_SYNOP
    this.pressureReducedToMeanSeaLevel =
      serviceSynop.PRESSURE_REDUCED_TO_MEAN_SEA_LEVEL
    this.twentyfourHourPressureChange =
      serviceSynop.TWENTYFOUR_HOUR_PRESSURE_CHANGE
    this.pressure = serviceSynop.PRESSURE
    this.airTemperature = serviceSynop.AIR_TEMPERATURE
    this.dewpointTemperature = serviceSynop.DEWPOINT_TEMPERATURE
    this.relativeHumidity = serviceSynop.RELATIVE_HUMIDITY
    this.horizontalVisibility = serviceSynop.HORIZONTAL_VISIBILITY
    this.totalPrecipitation24Hours = serviceSynop.TOTAL_PRECIPITATION_24_HOURS
    this.cloudCoverTotal = serviceSynop.CLOUD_COVER_TOTAL
    this.heightOfBaseOfCloud = serviceSynop.HEIGHT_OF_BASE_OF_CLOUD
    this.totalSnowDepth = serviceSynop.TOTAL_SNOW_DEPTH
    this.precipitationType = serviceSynop.PRECIPITATION_TYPE
    this.totalSunshine = serviceSynop.TOTAL_SUNSHINE
    this.totalPrecipitationOrTotalWaterEquivalent =
      serviceSynop.TOTAL_PRECIPITATION_OR_TOTAL_WATER_EQUIVALENT
    this.maximumTemperatureAtHeightAndOverPeriodSpecified =
      serviceSynop.MAXIMUM_TEMPERATURE_AT_HEIGHT_AND_OVER_PERIOD_SPECIFIED
    this.minimumTemperatureAtHeightAndOverPeriodSpecified =
      serviceSynop.MINIMUM_TEMPERATURE_AT_HEIGHT_AND_OVER_PERIOD_SPECIFIED
    this.windDirection = serviceSynop.WIND_DIRECTION
    this.windSpeed = serviceSynop.WIND_SPEED
    this.maximumWindGustDirection = serviceSynop.MAXIMUM_WIND_GUST_DIRECTION
    this.maximumWindGustSpeed = serviceSynop.MAXIMUM_WIND_GUST_SPEED
    this.netWaveRadiationIntegratedOverPeriodSpecified =
      serviceSynop.NET_WAVE_RADIATION_INTEGRATED_OVER_PERIOD_SPECIFIED
    this.diffuseSolarRadiationIntegratedOverPeriodSpecified =
      serviceSynop.DIFFUSE_SOLAR_RADIATION_INTEGRATED_OVER_PERIOD_SPECIFIED
    this.directSolarRadiationIntegratedOverPeriodSpecified =
      serviceSynop.DIRECT_SOLAR_RADIATION_INTEGRATED_OVER_PERIOD_SPECIFIED
  }

  getTemperatureCelsius() {
    return this.airTemperature ? (this.airTemperature - 273.15).toFixed(1) : ''
  }

  getDate() {
    const month = this.monthSynop.toLocaleString('es-ES', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })

    const day = this.daySynop.toLocaleString('es-ES', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })

    const hour = this.hourSynop.toLocaleString('es-ES', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })

    const minute = this.minuteSynop.toLocaleString('es-ES', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
    const date = `${this.yearSynop}-${month}-${day}T${hour}:${minute}:00`
    return DateService.parseDate(date, 'YYYY-MM-DDTHH:mm:ss')
  }
}
